<template>
  <v-card class="mb-4" elevation="2" rounded="lg">
    <v-card-title class="primary--text">
      <v-icon left color="primary">mdi-clipboard-check</v-icon>
      Varustelista (Valitse tarvittavat)
      <v-spacer></v-spacer>
      <v-btn icon color="primary" @click="$emit('share')" title="Jaa lista">
        <v-icon>mdi-share-variant</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-subtitle class="pb-0" v-if="selectedCount === 0">
      Valitse listasta tarvittavat välineet.
    </v-card-subtitle>
    <v-divider></v-divider>
    <v-card-text>
      <div v-if="selectedCount > 0" class="d-flex align-center mb-4">
        <div class="flex-grow-1 mr-4">
          <v-progress-linear
            :value="packedPercentage"
            height="20"
            rounded
            color="success"
          >
            <template v-slot:default="{ value }">
              <strong class="white--text" style="font-size: 12px"
                >{{ Math.ceil(value) }}% Pakattu</strong
              >
            </template>
          </v-progress-linear>
        </div>
        <div class="text-caption grey--text text-no-wrap">
          {{ packedCount }} / {{ selectedCount }}
        </div>
      </div>

      <v-list dense class="pa-0">
        <template v-for="(item, index) in displayItems">
          <v-list-item
            :key="index"
            :class="{
              'pl-8': item.indent,
              'grey lighten-5': !localChecklist[item.label],
              'white elevation-1 my-1 rounded': localChecklist[item.label],
            }"
          >
            <v-list-item-action class="mr-4">
              <v-checkbox
                v-model="localChecklist[item.label]"
                color="primary"
                dense
                hide-details
                @change="onChange"
              ></v-checkbox>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title
                :class="{ 'font-weight-medium': !item.indent }"
              >
                {{ item.label }}
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action v-if="localChecklist[item.label]">
              <v-btn
                :color="
                  localPackedItems[item.label] ? 'success' : 'grey lighten-2'
                "
                :class="{
                  'white--text': localPackedItems[item.label],
                  'grey--text text--darken-1': !localPackedItems[item.label],
                }"
                small
                depressed
                @click="togglePacked(item.label)"
              >
                <v-icon left small>{{
                  localPackedItems[item.label]
                    ? "mdi-check"
                    : "mdi-package-variant"
                }}</v-icon>
                {{ localPackedItems[item.label] ? "Pakattu" : "Pakkaa" }}
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "MuonitusChecklist",
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    packedItems: {
      type: Object,
      default: () => ({}),
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localChecklist: { ...this.value },
      localPackedItems: { ...this.packedItems },
      defaultItems: [
        { label: "Muonituslaatikot" },
        { label: "mukit", indent: true },
        { label: "jätesäkit", indent: true },
        { label: "käsidesi", indent: true },
        { label: "tarvikkeet", indent: true },
        { label: "Kanisterit" },
        { label: "mehu", indent: true },
        { label: "vesi", indent: true },
        { label: "käsienpesu", indent: true },
        { label: "Termarit" },
        { label: "kahvi", indent: true },
        { label: "teevesi", indent: true },
        { label: "Kylmä/lämpölaatikot (1-2kpl)" },
        { label: "Taittopöydät (1-2kpl)" },
        { label: "Telttakatos / Ilmakaariteltat (harkinnan mukaan)" },
        { label: "Valaistus (pimeään aikaan)" },
        { label: "Muonitukseen tarvittava vaatetus" },
        { label: "Käsipaperit" },
      ],
    };
  },
  computed: {
    displayItems() {
      return this.items && this.items.length > 0
        ? this.items
        : this.defaultItems;
    },
    selectedCount() {
      return this.displayItems.filter((i) => this.localChecklist[i.label])
        .length;
    },
    packedCount() {
      return this.displayItems.filter(
        (i) => this.localChecklist[i.label] && this.localPackedItems[i.label]
      ).length;
    },
    packedPercentage() {
      if (this.selectedCount === 0) return 0;
      return (this.packedCount / this.selectedCount) * 100;
    },
  },
  watch: {
    value: {
      handler(val) {
        this.localChecklist = { ...val };
      },
      deep: true,
    },
    packedItems: {
      handler(val) {
        this.localPackedItems = { ...val };
      },
      deep: true,
    },
  },
  methods: {
    onChange() {
      // If unchecked, also remove from packed
      for (const key in this.localChecklist) {
        if (!this.localChecklist[key] && this.localPackedItems[key]) {
          this.$delete(this.localPackedItems, key);
        }
      }
      this.$emit("input", this.localChecklist);
      this.$emit("update:packedItems", this.localPackedItems);
      this.$emit("save");
    },
    togglePacked(label) {
      this.$set(this.localPackedItems, label, !this.localPackedItems[label]);
      this.onPackedChange();
    },
    onPackedChange() {
      this.$emit("update:packedItems", this.localPackedItems);
      this.$emit("save");
    },
  },
};
</script>
